import * as React from 'react';
const SvgComponent = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={25} height={25} {...props}>
    <path
      fill="#ff4646"
      d="M25 23.438A1.553 1.553 0 0 1 23.456 25H1.544A1.553 1.553 0 0 1 0 23.438c0-5.177 4.712-9.375 9.831-9.375h5.338c5.119 0 9.831 4.2 9.831 9.375M12.5 0a6.214 6.214 0 0 0-6.178 6.249A6.179 6.179 0 1 0 12.5 0"
      data-name="Path 15694"
    />
    <path
      fill="#fe2c2c"
      d="M5.076 15.304a10.355 10.355 0 0 0-2.08 1.504 9.094 9.094 0 0 0-3 6.629 1.552 1.552 0 0 0 1.543 1.562h15.666Z"
      data-name="Path 15695"
    />
  </svg>
);
export default SvgComponent;
